const actions = {
  FETCH_SUPPORT_DEVICES: 'FETCH_SUPPORT_DEVICES',
  FETCH_SUPPORT_DEVICES_SUCCESS: 'FETCH_SUPPORT_DEVICES_SUCCESS',
  FETCH_SUPPORT_DEVICES_ERROR: 'FETCH_SUPPORT_DEVICES_ERROR',
  FETCH_SUPPORT_DEVICE_LOG: 'FETCH_SUPPORT_DEVICE_LOG',
  FETCH_SUPPORT_DEVICE_LOG_SUCCESS: 'FETCH_SUPPORT_DEVICE_LOG_SUCCESS',
  FETCH_SUPPORT_DEVICE_LOG_ERROR: 'FETCH_SUPPORT_DEVICE_LOG_ERROR',
  REQUEST_SUPPORT_DEVICE_UPDATE: 'REQUEST_SUPPORT_DEVICE_UPDATE',
  REQUEST_SUPPORT_DEVICE_UPDATE_SUCCESS: 'REQUEST_SUPPORT_DEVICE_UPDATE_SUCCESS',
  REQUEST_SUPPORT_DEVICE_UPDATE_ERROR: 'REQUEST_SUPPORT_DEVICE_UPDATE_ERROR',
  REQUEST_SUPPORT_DEVICE_CANCEL: 'REQUEST_SUPPORT_DEVICE_CANCEL',
  REQUEST_SUPPORT_DEVICE_CANCEL_SUCCESS: 'REQUEST_SUPPORT_DEVICE_CANCEL_SUCCESS',
  REQUEST_SUPPORT_DEVICE_CANCEL_ERROR: 'REQUEST_SUPPORT_DEVICE_CANCEL_ERROR',
  FETCH_SUPPORT_DEVICE_VERSIONS: 'FETCH_SUPPORT_DEVICE_VERSIONS',
  FETCH_SUPPORT_DEVICE_FIRMWARE_VERSIONS: 'FETCH_SUPPORT_DEVICE_FIRMWARE_VERSIONS',
  FETCH_SUPPORT_DEVICE_VERSIONS_SUCCESS: 'FETCH_SUPPORT_DEVICE_VERSIONS_SUCCESS',
  FETCH_SUPPORT_DEVICE_FIRMWARE_VERSION_SUCCESS: 'FETCH_SUPPORT_DEVICE_FIRMWARE_VERSION_SUCCESS',
  FETCH_SUPPORT_DEVICE_VERSIONS_ERROR: 'FETCH_SUPPORT_DEVICE_VERSIONS_ERROR',
  REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE: 'REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE',
  REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE_SUCCESS: 'REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE_SUCCESS',
  REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE_ERROR: 'REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE_ERROR',
  REQUEST_SUPPORT_LOG: 'REQUEST_SUPPORT_LOG',
  REQUEST_SUPPORT_LOG_SUCCESS: 'REQUEST_SUPPORT_LOG_SUCCESS',
  REQUEST_SUPPORT_LOG_ERROR: 'REQUEST_SUPPORT_LOG_ERROR',
  REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE: 'REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE',
  REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_SUCCESS: 'REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_SUCCESS',
  REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_ERROR: 'REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE_ERROR',
  DOWNLOAD_DEVICE_CSV: 'DOWNLOAD_DEVICE_CSV',
  DOWNLOAD_DEVICE_CSV_SUCCESS: 'DOWNLOAD_DEVICE_CSV_SUCCESS',
  DOWNLOAD_DEVICE_CSV_ERROR: 'DOWNLOAD_DEVICE_CSV_ERROR',
  FETCH_SUPPORT_DEVICES_UPDATED: 'FETCH_SUPPORT_DEVICES_UPDATED',
  FETCH_SUPPORT_DEVICES_UPDATED_SUCCESS: 'FETCH_SUPPORT_DEVICES_UPDATED_SUCCESS',
  FETCH_SUPPORT_DEVICES_UPDATED_ERROR: 'FETCH_SUPPORT_DEVICES_UPDATED_ERROR',
  FETCH_EXIT_KIOSK_PIN: 'FETCH_EXIT_KIOSK_PIN',
  FETCH_EXIT_KIOSK_PIN_SUCCESS: 'FETCH_EXIT_KIOSK_PIN_SUCCESS',
  FETCH_EXIT_KIOSK_PIN_ERROR: 'FETCH_EXIT_KIOSK_PIN_ERROR',


    fetchDevices: (search) => ({
        type: actions.FETCH_SUPPORT_DEVICES,
        search,
    }),
    fetchDeviceLog: (id) => ({
        type: actions.FETCH_SUPPORT_DEVICE_LOG,
        id,
    }),
    fetchVersions: (version_type, current_version) => {
        return ({
            type: actions.FETCH_SUPPORT_DEVICE_VERSIONS,
            version_type,
            current_version
        })
    },
    fetchFirmwareVersions: (version_type, current_version) => {
        return ({
            type: actions.FETCH_SUPPORT_DEVICE_FIRMWARE_VERSIONS,
            version_type,
            current_version
        })
    },
    updateDevice: (deviceIds, versionId, version_type, updatePackageId) => ({
        type: actions.REQUEST_SUPPORT_DEVICE_UPDATE,
        deviceIds,
        versionId,
        version_type,
        updatePackageId
    }),
    updateDeviceNew: (deviceIds, versionId, version_type, updatePackageId, totalItems, search) => ({
        type: actions.REQUEST_SUPPORT_DEVICE_UPDATE,
        deviceIds,
        versionId,
        version_type,
        updatePackageId,
        totalItems,
        search
    }),
    deleteDevicePackage: (packageId) => ({
        type: actions.REQUEST_SUPPORT_DEVICE_PACKAGE_DELETE,
        packageId
    }),
    updateDevicePhoneInfo: (deviceId, SIMNumber, IMEI, clearToken) => ({
        type: actions.REQUEST_SUPPORT_DEVICE_PHONE_INFO_UPDATE,
        deviceId,
        SIMNumber,
        IMEI,
        clearToken,
    }),
    cancelDevicesUpdate: (deviceIds) => ({
        type: actions.REQUEST_SUPPORT_DEVICE_CANCEL,
        deviceIds
    }),
    requestLogs: (id, startDate, endDate, logFile, dispenseImage) => ({
        type: actions.REQUEST_SUPPORT_LOG,
        id,
        startDate,
        endDate,
        logFile,
        dispenseImage
    }),
    fetchDeviceCsv: (search) => ({
        type: actions.DOWNLOAD_DEVICE_CSV,
        search
    }),
    fetchDevicesUpdated: (search) => ({
        type: actions.FETCH_SUPPORT_DEVICES_UPDATED,
        search,
    }),
    fetchPin: (payload) => {
        return {
            type: actions.FETCH_EXIT_KIOSK_PIN,
            payload,
        };
    },
    fetchPinSuccess: (devices) => ({
        type: actions.FETCH_EXIT_KIOSK_PIN_SUCCESS,
        devices,
    })
}
export default actions;
